module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"repair_inspect.is_not_inspect.message":"ไม่ได้ตรวจสอบหลังซ่อม"}}')
  delete Component.options._Ctor
}
